import NoProspect from '../../../../assets/NoProspect.svg'
export const NoProspectFound = () => {
    return (
        <div style={{margin: '120px auto', textAlign: 'center'}}>
            <img src={NoProspect}></img>
            <div className='text_body_big_light_bold' style={{marginTop: 32}}>No prospect found</div>
        </div>
    )
}